var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearchButton = function SvgSearchButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.803 13.684a6.8 6.8 0 0 0 4.188-1.444l3.76 3.76 1.21-1.21-3.76-3.759a6.8 6.8 0 0 0 1.444-4.189A6.85 6.85 0 0 0 7.803 0 6.85 6.85 0 0 0 .96 6.842a6.85 6.85 0 0 0 6.842 6.842Zm0-11.973a5.137 5.137 0 0 1 5.131 5.131 5.137 5.137 0 0 1-5.131 5.131A5.137 5.137 0 0 1 2.67 6.842a5.137 5.137 0 0 1 5.132-5.131Z",
    fill: "#000"
  })));
};
export default SvgSearchButton;